// en.js — PunchLog English locale
// Auto-extracted from: AppShell, EntryList, PlannerPanel, WorkplaceConfig,
//   CalendarGrid, ShiftView, OcrView
export default {

  // ── AppShell ──────────────────────────────────────────────────────────────
  shell_tagline:            'Verified Labor Data',
  shell_navAriaLabel:       'Main navigation',
  shell_sidebarAriaLabel:   'Main navigation',
  shell_online:             'Online',
  shell_offline:            'Offline',
  shell_switchToLight:      'Switch to light mode',
  shell_switchToDark:       'Switch to dark mode',
  shell_collapseSidebar:    'Collapse sidebar',
  shell_expandSidebar:      'Expand sidebar',
  shell_syncedAgo:          'Synced {n}',
  shell_syncedJustNow:      'just now',
  shell_syncedMinutes:      '{n}m ago',
  shell_syncedHours:        '{n}h ago',
  shell_tabTrack:           'Track',
  shell_tabPlanner:         'Planner',
  shell_tabScan:            'Scan',
  shell_tabSettings:        'Settings',

  // ── EntryList ─────────────────────────────────────────────────────────────
  entry_filterAll:          'All',
  entry_filterShift:        'Shift',
  entry_filterTravel:       'Travel',
  entry_filterOnCall:       'On-Call',
  entry_filterJobSearch:    'Job Search',
  entry_allWorkplaces:      'All workplaces',
  entry_groupConcurrent:    'Group concurrent',
  entry_showVariance:       'Schedule variance',
  entry_varianceHint:       '{n}h vs scheduled',
  entry_predictiveViolation: 'Predictive scheduling violation (<24h notice)',
  entry_colVariance:        'Variance',
  entry_clearFilters:       'Clear',

  entry_emptyTitle:         'No entries yet',
  entry_emptyTitleFiltered: 'No matching entries',
  entry_emptySub:           'Clock in on the Track tab to start recording your time.',
  entry_emptySubFiltered:   'Try clearing the filters above.',

  entry_colDate:            'Date',
  entry_colIn:              'In',
  entry_colOut:             'Out',
  entry_colHours:           'Hours',
  entry_colType:            'Type',
  entry_colWorkplace:       'Workplace',
  entry_colJob:             'Job',
  entry_colStatus:          'Status',

  entry_typeShift:          'shift',
  entry_typeTravel:         'travel',
  entry_typeOnCall:         'on-call',
  entry_typeJobSearch:      'job-search',
  entry_concurrentBadge:    '{n}× concurrent',

  entry_statusOk:           'OK',
  entry_statusSealed:       'Sealed',
  entry_signedLock:         'Sealed: record is immutable',
  entry_statusModified:     'Modified',

  entry_concurrentHeading:  '{n} concurrent activities, full span {hours}h',
  entry_concurrentHint:     'Switch to Split view to edit or delete individual entries.',
  entry_segColIn:           'In',
  entry_segColOut:          'Out',
  entry_segColHours:        'Hours',
  entry_segColType:         'Type',
  entry_segColJob:          'Job',

  entry_groupEntries:       '{n} entry · {hours}h | {n} entries · {hours}h',

  entry_dlBreak:            'Break',
  entry_breakUnpaid:        '{n}m unpaid',
  entry_dlJob:              'Job',
  entry_dlCreated:          'Created',
  entry_dlModified:         'Modified',
  entry_dlNotes:            'Notes',

  entry_editDate:           'Date',
  entry_editClockIn:        'Clock In',
  entry_editClockOut:       'Clock Out',
  entry_editBreak:          'Break (min)',
  entry_editType:           'Type',
  entry_editTypeShift:      'Shift',
  entry_editTypeTravel:     'Travel',
  entry_editTypeOnCall:     'On-Call',
  entry_editTypeJobSearch:  'Job Search',
  entry_editJobTitle:       'Job Title',
  entry_editJobPlaceholder: 'e.g. Line Cook',
  entry_editNotes:          'Notes',
  entry_btnSave:            'Save',
  entry_btnCancel:          'Cancel',
  entry_btnEdit:            'Edit',
  entry_btnDelete:          'Delete',

  entry_deleteConfirm:      'Delete this entry? This cannot be undone.',
  entry_deleteBtnConfirm:   'Yes, delete',

  entry_selectRow:          'Select row',
  entry_bulkToggle:         'Bulk Select',
  entry_bulkSelected:       '{n} selected',
  entry_bulkDelete:         'Delete Selected',
  entry_bulkClear:          'Clear Selection',
  entry_bulkWp:             'Change workplace…',
  entry_bulkWpLabel:        'Bulk workplace',
  entry_bulkType:           'Change type…',
  entry_bulkTypeLabel:      'Bulk entry type',
  entry_bulkApply:          'Apply',
  entry_colCostCode:        'Code',

  // ── PlannerPanel ─────────────────────────────────────────────────────────
  planner_importTitle:      'Import',
  planner_importDesc:       'Accepts JSON, CSV, or Excel (.xls SpreadsheetML) exported from PunchLog. Each row becomes a time entry.',
  planner_chooseFile:       'Choose file…',
  planner_importedSuccess:  'Imported {n} entry. | Imported {n} entries.',
  planner_xlsxError:        '.xlsx is not supported. Export as .xls or CSV from PunchLog and reimport.',

  planner_exportTitle:      'Export',
  planner_exportDolLabel:   'Timesheet Report',
  planner_exportDolSub:     'PDF with all hours and entries',
  planner_exportInvoiceLabel: 'Invoice PDF',
  planner_exportInvoiceSub: 'PDF billable hours invoice',
  planner_exportCsvLabel:   'CSV',
  planner_exportCsvSub:     'Comma-separated, opens in Excel & Numbers',
  planner_exportExcelLabel: 'Excel',
  planner_exportExcelSub:   'SpreadsheetML, native .xls format',
  planner_exportJsonLabel:  'JSON',
  planner_exportJsonSub:    'Full audit trail with all fields',

  planner_exportGroupTimeEntries: 'Time Entries',
  planner_exportGroupSchedules:   'Schedules',
  planner_exportSchedCsvLabel:    'Schedule (CSV)',
  planner_exportSchedCsvSub:      'date, employee, workplace, start/end times',
  planner_exportSchedExcelLabel:  'Schedule (Excel)',
  planner_exportSchedExcelSub:    'SpreadsheetML, import-compatible format',
  planner_includeSeal:     'Include cryptographic seal',
  planner_includeSealHint: 'Adds JWS token or unsigned notice to the PDF',
  planner_destLabel:       'Save to',
  planner_destLocal:       'Download',
  planner_destDrive:       'Save to Drive',
  planner_destDriveHint:   'Connect Google Drive in Settings to enable',
  planner_driveSaved:      'Saved to Google Drive',
  planner_driveUploading:  'Uploading {name}…',
  planner_driveError:      'Upload failed. Check your connection and try again.',
  planner_moreFormats:     'More formats',

  planner_btnExport:        'Export…',
  planner_btnImport:        'Import…',

  planner_sectionSummary:   'Summary',
  planner_statPeriod:       'Period',
  planner_statWorkplace:    'Workplace',
  planner_statTotalHours:   'Total Hours',
  planner_statEstPay:       'Est. Pay',
  planner_statDays:         'Days',
  planner_statOtDays:       'OT Days',
  planner_statModified:     'Modified',
  planner_statUnsigned:     'Unsealed',

  planner_mobileTotalHours: '{n}h total',
  planner_mobileDays:       '{n} days',
  planner_mobileOt:         '{n} OT',
  planner_mobileUnsigned:   '{n} unsealed',

  planner_sectionPeriod:    'Period',
  planner_filterThisWeek:   'This Week',
  planner_filterThisMonth:  'This Month',
  planner_filterAll:        'All',
  planner_filterCustom:     'Custom',
  planner_dateRangeSep:     'to',
  planner_customFrom:       'Start date',
  planner_customTo:         'End date',

  planner_sectionWorkplace: 'Workplace',
  planner_sectionType:      'Entry Type',
  planner_sectionGroupBy:   'Group By',
  planner_groupNone:        'None',
  planner_groupDay:         'Day',
  planner_groupWeek:        'Week',
  planner_groupShift:       'Shift',
  planner_groupMonth:       'Month',
  planner_invoiceGrouping:  'Line items by',
  planner_invoiceFrom:      'From (billing profile)',
  planner_invoiceFromDefault: 'Default profile',
  planner_invoiceNoProfile: 'Add a billing profile in Settings to show your name and address on invoices.',
  planner_invoiceLimitReached: 'Free tier invoice limit reached (5/month). Upgrade to Pro for unlimited invoices.',
  planner_groupHint:        'Applies when switching to list view',

  planner_sectionAdd:       'Add',
  planner_addLogEntry:      'Log Entry',
  planner_addSchedule:      'Schedule',

  planner_entryFormDate:    'Date',
  planner_entryFormIn:      'In',
  planner_entryFormOut:     'Out',
  planner_entryFormBreak:   'Break',
  planner_entryFormPlace:   'Place',
  planner_entryBtnSaved:    'Saved!',
  planner_entryBtnSaving:   'Saving…',
  planner_entryBtnSave:     'Save Entry',

  planner_schedFormName:    'Name',
  planner_schedFormNamePlaceholder: 'e.g. Mon–Fri 9–5',
  planner_schedFormStart:   'Start',
  planner_schedFormEnd:     'End',
  planner_schedFormDays:    'Days',
  planner_schedFormBreak:   'Break',
  planner_schedBtnSaved:    'Saved!',
  planner_schedBtnSaving:   'Saving…',
  planner_schedBtnSave:     'Save Schedule',
  planner_schedBtnApply:    'Apply to Range',
  planner_rosterBizOnly:    'Roster import requires Business tier.',

  planner_dowSu:            'Su',
  planner_dowM:             'M',
  planner_dowTu:            'Tu',
  planner_dowW:             'W',
  planner_dowTh:            'Th',
  planner_dowF:             'F',
  planner_dowSa:            'Sa',

  planner_viewList:         'List',
  planner_viewTimesheet:    'Timesheet',
  planner_viewCalendar:     'Calendar',
  planner_unsignedSeal:     '{n} unsealed',

  // ── Timesheet grid ────────────────────────────────────────────────────────
  ts_addCode:                'Add code',
  ts_noCodesTitle:           'No cost codes configured',
  ts_noCodesSub:             'Add a code below or configure codes in workplace settings.',
  ts_codePlaceholder:        'CODE',
  ts_labelPlaceholder:       'Label',
  ts_wpGroup:                '{name}',
  ts_week:                   'Week',
  ts_total:                  'Total',
  planner_timesheetWeekTotal: 'Week',
  planner_timesheetTotal:    'Total',
  planner_timesheetAutosave: 'Auto-save entries',
  planner_timesheetSaveAll:  'Save All',
  planner_calMode3Day:       '3 Day',
  planner_calModeWorkWeek:   'Work Week',
  planner_calModeWeek:       'Week',
  planner_calModeMonth:      'Month',
  planner_calNavToday:       'Today',

  // ── CalendarGrid ─────────────────────────────────────────────────────────
  calendar_prevMonth:       'Previous month',
  calendar_nextMonth:       'Next month',
  calendar_dowSun:          'Sun',
  calendar_dowMon:          'Mon',
  calendar_dowTue:          'Tue',
  calendar_dowWed:          'Wed',
  calendar_dowThu:          'Thu',
  calendar_dowFri:          'Fri',
  calendar_dowSat:          'Sat',
  calendar_hoursLogged:     '{n}h',
  calendar_hoursPlanned:    '{n}h planned',
  calendar_hoursOf:         'of {n}h',
  calendar_entryCount:      '{n} entries',
  calendar_legendWorked:    'Worked',
  calendar_legendOt:        'OT >8h',
  calendar_legendScheduled: 'Scheduled',
  calendar_legendIssue:     'Modified/Unsigned',

  // ── WorkplaceConfig ───────────────────────────────────────────────────────
  config_sectionWorkplaces: 'Workplaces',
  config_unnamed:           'Unnamed',
  config_noWorkplaces:      'No workplaces yet. Add one below.',
  config_btnAddWorkplace:   'Add Workplace',

  config_sectionSchedules:  'Schedule Templates',
  config_noSchedules:       'No templates yet',
  config_btnAddTemplate:    'Add Template',

  config_sectionBillingProfiles: 'Billing Profiles',
  config_noBillingProfiles:      'No billing profiles yet',
  config_btnAddBillingProfile:   'Add profile',
  config_defaultWorkplaceName:   'My Workplace',
  config_unitPerHour:            '/hr',
  config_newBillingProfile:      'New Billing Profile',
  config_editBillingProfile:     'Edit Billing Profile',
  config_bpIdentityHeader:       'Identity',
  config_deleteBpConfirm:        'Delete this billing profile?',
  config_bpAddressHeader:        'Address',
  config_bpPreferencesHeader:    'Preferences',
  config_bpName:                 'Name',
  config_bpNamePlaceholder:      'e.g. Acme LLC or Jane Smith',
  config_bpNameHint:             'Appears as the From field on invoices',
  config_bpEmail:                'Email',
  config_bpEmailPlaceholder:     'billing email address',
  config_bpDefault:              'Default profile',
  config_bpDefaultHint:          'Use this profile when none is selected',

  config_sectionAppSettings: 'App Settings',
  config_dataPrivacy:       'Data & Privacy',
  config_dataPrivacySub:    'Export, clear records, storage',
  config_syncCloud:         'Sync & Cloud',
  config_syncCloudSub:      'Cloud backup and synchronization',
  sync_chooseHint:          'Choose a cloud provider to sync your data across devices.',
  sync_googleDrive:         'Google Drive',
  sync_oneDrive:            'OneDrive',
  sync_statusConnecting:    'Connecting…',
  sync_statusExpired:       'Session expired',
  sync_statusSyncing:       'Syncing…',
  sync_statusError:         'Error',
  sync_statusConnected:     'Connected',
  sync_btnReconnect:        'Reconnect',
  sync_lastSync:            'Last sync: {time}',
  sync_btnSyncNow:          'Sync Now',
  sync_btnDisconnect:       'Disconnect',
  sync_bpDefault:           'default',
  config_planFeatures:      'Plan & Features',
  config_integrations:      'Integrations',
  config_integrationsSub:   'Webhooks, outbound events',
  config_teams:             'Teams',
  config_teamsSub:          'Multi-member workplaces',

  config_newWorkplace:      'New Workplace',
  config_editWorkplace:     'Edit Workplace',

  config_identityHeader:    'Identity',
  config_addressHeader:     'Address',
  config_workplaceName:              'Name',
  config_workplaceNamePlaceholder:   'e.g. Downtown Bistro',
  config_workplaceNamePlaceholderContract: 'e.g. Acme Corp – Phase 1',
  config_workplaceNameHint:          'Use a unique name per employer or contract engagement',
  config_employerLegalName:          'Legal Entity Name',
  config_employerLegalNamePlaceholder: 'For official records',
  config_employerLegalNameHint:      'Appears on exported reports and invoices',
  config_address:           'Address',
  config_addressPlaceholder: 'Street, City, State, ZIP',
  config_address1:           'Street Address',
  config_address1Placeholder: '123 Main St',
  config_address2:           'Suite / Apt',
  config_address2Placeholder: 'Suite 100',
  config_city:               'City',
  config_zip:                'ZIP / Postal Code',
  config_stateField:         'State',
  config_phone:              'Phone',
  config_phonePlaceholder:   '+1 (555) 000-0000',
  config_defaultJobTitle:    'Default Job Title',
  config_defaultJobTitlePlaceholder: 'e.g. Line Cook, Software Engineer',
  config_defaultJobTitleHint: 'Auto-fills job title on new entries for this workplace',

  config_payHeader:         'Pay',
  config_payStructure:      'Pay Structure',
  config_payHourly:         'Hourly',
  config_paySalary:         'Salary',
  config_payCommission:     'Commission',
  config_isContract:        'This is a contract / freelance engagement',

  config_hourlyRate:        'Hourly Rate',
  config_hourlyRateHint:    'State min: ${min}/hr',

  config_salaryAmount:         'Salary Amount',
  config_salaryAmountContract: 'Fixed Fee',
  config_salaryAmountContractHint: 'Fixed periodic fee billed regardless of hours logged',
  config_payPeriod:            'Pay Period',
  config_payPeriodWeekly:   'Weekly',
  config_payPeriodBiweekly: 'Bi-weekly',
  config_payPeriodSemimonthly: 'Semi-monthly (24×/yr)',
  config_payPeriodMonthly:  'Monthly',
  config_payPeriodAnnual:   'Annual',

  config_baseRate:              'Base Rate (optional)',
  config_baseRateHint:          '0 = commission-only',
  config_baseRateContract:      'Base Hourly Fee (optional)',
  config_baseRateHintContract:  'Leave blank or enter 0 for commission-only',
  config_commissionPct:         'Commission %',

  config_contractBilling:               'Client Billing Type',
  config_contractBillingFixed:          'Fixed Price',
  config_contractBillingRetainer:       'Retainer',
  config_contractBillingHourly:         'Hourly',
  config_contractRetainerPlusHourlyHint:'Retainer base + tracked hours billed on top',
  config_contractAmount:                'Amount',
  config_contractPeriod:                'Billing Period',
  config_contractPeriodQuarterly:       'Quarterly',
  config_contractDesc:                  'Scope / Deliverable',
  config_contractDescPlaceholder:       'e.g. Phase 1: API integration',

  config_hoursOtHeader:     'Hours & OT',
  config_defaultHoursDay:          'Default Hours/Day',
  config_defaultUnpaidBreak:       'Default Unpaid Break',
  config_defaultUnpaidBreakHint:   'Pre-filled on new entries for this workplace',
  config_dailyOtThreshold:  'Daily OT Threshold',
  config_dailyOtHint:       '0 = no daily OT',
  config_weeklyOtThreshold: 'Weekly OT Threshold',

  config_complianceHeader:  'Compliance',
  config_flsaClass:         'FLSA Classification',
  config_flsaNonExempt:     'Non-exempt (eligible for OT)',
  config_flsaExempt:        'Exempt (salaried, no OT)',
  config_flsaContractor:    'Independent Contractor (1099)',
  config_flsaTrainee:       'Trainee / Apprentice',

  config_stateOtRules:      'State (OT Rules)',
  config_timeRounding:      'Time Rounding',
  config_roundNone:         'None (exact)',
  config_roundNearest15:    'Nearest 15 min',
  config_roundUp15:         'Round up 15 min',
  config_roundDown15:       'Round down 15 min',
  config_roundingHint:      'Applied to clock-in/out times',

  config_costCodesHeader:   'Cost Codes',
  config_costCodesLabel:    'Active codes for this workplace',
  config_costCodesHint:     'Defaults shown; per-workplace editor coming soon',

  config_btnSave:           'Save',
  config_btnDelete:         'Delete',
  config_btnCancel:         'Cancel',
  config_btnSaving:         'Saving…',
  config_btnSaveChanges:    'Save Changes',
  config_savedMsg:          'Saved',

  config_newScheduleTemplate: 'New Schedule Template',
  config_editTemplate:      'Edit Template',
  config_scheduleHeader:    'Schedule',
  config_templateName:      'Template Name',
  config_templateNamePlaceholder: 'e.g. Mon–Fri 9–5',
  config_linkedWorkplace:   'Linked Workplace',
  config_linkedWorkplaceAny: 'Any',
  config_daysOfWeek:        'Days of Week',
  config_startTime:         'Start Time',
  config_endTime:           'End Time',
  config_unpaidBreak:       'Unpaid Break',
  config_btnSaveTemplate:   'Save Template',

  config_noDaysScheduled:   'No days',
  config_dayMon:            'Mon',
  config_dayTue:            'Tue',
  config_dayWed:            'Wed',
  config_dayThu:            'Thu',
  config_dayFri:            'Fri',
  config_daySat:            'Sat',
  config_daySun:            'Sun',

  config_dataHeader:        'Data & Privacy',
  config_exportSectionHeader: 'Export',
  config_exportDesc:        'Download a complete copy of all local data as JSON: workplaces, schedules, and every time entry including the full audit trail.',
  config_btnExportAll:      'Export All Data (JSON)',
  config_dangerZone:        'Danger Zone',
  config_clearDesc:         'Permanently delete all local time entries. Workplace settings and schedule templates are not affected. This cannot be undone.',
  config_btnClearRecords:   'Clear Time Records',

  config_clearTimeLabel:    'Clear time records',
  config_clearTimeDesc:     'Removes all shift entries. Workplaces, schedules, and billing profiles are kept.',
  config_clearTimeConfirm:  'All time entries will be permanently deleted. Workplace and billing settings are not affected.',

  config_clearWorkplacesLabel:   'Remove workplaces & schedules',
  config_clearWorkplacesDesc:    'Removes all workplaces, schedule templates, and shift schedules. Time entries are kept.',
  config_clearWorkplacesConfirm: 'All workplaces, schedule templates, and shift schedules will be permanently deleted. Time entries are not affected.',
  config_btnClearWorkplaces:     'Remove Workplaces',

  config_clearBillingLabel:    'Remove billing profiles',
  config_clearBillingDesc:     'Removes all billing profiles. Time entries and workplaces are kept.',
  config_clearBillingConfirm:  'All billing profiles will be permanently deleted.',
  config_btnClearBilling:      'Remove Billing Profiles',

  config_resetAllLabel:    'Reset everything',
  config_resetAllDesc:     'Wipes all local data: time entries, workplaces, schedules, billing profiles, and signed bundles. Starts fresh.',
  config_resetAllConfirm:  'Every piece of local data will be permanently erased, including signed audit bundles. This cannot be undone.',
  config_btnResetAll:      'Reset All Local Data',

  config_sheetImportHeader:   'Import from Google Sheets',
  config_sheetImportDesc:     'Paste a link to a Google Sheet that contains time entry data. The first row must be a header row.',
  config_sheetUrlLabel:       'Sheet URL',
  config_sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/…',
  config_sheetConflict:       'When an imported entry overlaps an existing one',
  config_sheetConflictSkip:   'Skip (keep existing)',
  config_sheetConflictOver:   'Overwrite existing',
  config_sheetConflictKeep:   'Keep both',
  config_sheetDefaultWp:      'Assign to workplace (optional)',
  config_sheetDefaultWpNone:  'No workplace',
  config_sheetBtnImport:      'Import Entries',
  config_sheetConnectHint:    'Connect Google Drive in Settings → Sync to enable Sheet import.',
  config_sheetImporting:      'Importing…',
  config_sheetDone:           'Done: {imported} imported, {skipped} skipped.',
  config_sheetErrors:         '{count} row(s) had errors.',
  config_sheetBadUrl:         'Could not find a Sheet ID in that URL.',

  config_dangerExportHint: 'Optionally export a backup first. You can re-import it later.',
  config_btnCancel:        'Cancel',
  config_btnConfirmDelete: 'Delete',
  config_aboutHeader:       'About',
  config_aboutVersion:      'Version',
  config_aboutStorage:      'Storage',
  config_aboutStorageValue: 'On-device (IndexedDB)',
  config_aboutServerSync:   'Server sync',
  config_aboutServerSyncValue: 'None (Free tier)',
  config_aboutAuditTrail:   'Audit trail',
  config_aboutAuditTrailValue: 'Immutable, local only',

  config_planHeader:        'Plan & Features',
  config_planFree:          'Free',
  config_planSoon:          'Soon',
  config_planPerMonth:      '/mo',
  config_planCurrentBadge:  'Current',
  config_planUpgrade:       'Upgrade',

  config_integrationsHeader: 'Integrations',
  config_webhookWarning:    'Webhooks require a Pro subscription. Configure now; events queue until you upgrade.',
  config_webhookHeader:     'Webhook Endpoint',
  config_webhookDesc:       'PunchLog sends a signed POST to your URL on each event. Verify requests with the X-PunchLog-Signature HMAC-SHA256 header.',
  config_webhookUrlLabel:   'Endpoint URL',
  config_webhookUrlPlaceholder: 'https://example.com/webhook',
  config_webhookUrlHint:    'Must be HTTPS in production',
  config_webhookSecretLabel: 'Signing Secret',
  config_webhookSecretPlaceholder: 'Random string, ≥ 32 chars',
  config_webhookSecretHint: 'Used to compute X-PunchLog-Signature. Keep this private.',
  config_btnSaveWebhook:    'Save',
  config_btnTestPayload:    'Test Payload',
  config_btnRemoveWebhook:  'Remove',
  config_webhookSaved:      'Saved.',
  config_emittedEventsHeader: 'Emitted Events',

  config_evtGroupEntries:   'Time Entries',
  config_evtShiftCreated:   'New time entry saved',
  config_evtShiftUpdated:   'Time entry edited',
  config_evtShiftDeleted:   'Time entry removed',
  config_evtShiftSigned:    'Batch sealed with cryptographic signature',
  config_evtGroupWorkplaces: 'Workplaces',
  config_evtWpCreated:      'New workplace configuration added',
  config_evtWpUpdated:      'Workplace settings changed',
  config_evtWpDeleted:      'Workplace removed',
  config_evtGroupSchedules: 'Schedules',
  config_evtSchedCreated:   'New schedule template saved',
  config_evtSchedUpdated:   'Schedule template edited',
  config_evtSchedDeleted:   'Schedule template removed',
  config_evtGroupInvoices:  'Invoices & Exports',
  config_evtInvoiceCreated: 'Invoice generated',
  config_evtDataExported:   'Full data export downloaded',
  config_evtGroupSync:      'Sync',
  config_evtSyncQueued:     'Entry staged while offline',
  config_evtSyncFlushed:    'Pending queue sent after reconnect',
  config_evtGroupOcr:       'OCR',
  config_evtScanCreated:    'OCR document scan saved',

  config_teamsHeader:       'Teams',
  config_teamsComingSoon:   'Coming Soon',
  config_teamsSoonDesc:     'Teams lets multiple members share a workplace and gives managers a read-only audit view without sharing credentials.',
  config_teamsFeature1:     'Up to 25 members per workplace',
  config_teamsFeature2:     'Shared schedule visibility',
  config_teamsFeature3:     'Manager audit dashboard',
  config_teamsFeature4:     'Role-based access: Admin and Member',

  config_deleteWorkplaceConfirm: 'Delete {name}? This cannot be undone.',
  config_deleteScheduleConfirm:  'Delete {name}?',
  config_clearRecordsConfirm:    'Delete all local time records? This cannot be undone.',

  // ── ShiftView ─────────────────────────────────────────────────────────────
  shift_firstRunTitle:      'Welcome to PunchLog',
  shift_firstRunDesc:       'Track your time, protect your wages, and export tamper-proof timesheets, right on your device.',
  shift_firstRunStep1:      'Add a workplace (your employer or client)',
  shift_firstRunStep2:      'Clock in when your shift starts',
  shift_firstRunStep3:      'Export a timesheet whenever you need it',
  shift_noWorkplaceBanner:  'No workplace configured.',
  shift_addDefault:         'Add a Default',
  shift_createOne:          'Create One',
  shift_advancedSetup:      'Advanced setup →',

  shift_newWorkplaceTitle:  'New Workplace',
  shift_wpNameLabel:        'Name',
  shift_wpNamePlaceholder:  'e.g. Acme Diner',
  shift_wpRateLabel:        'Hourly Rate ($/hr)',
  shift_wpDefaultHours:     'Default Hours/Day',
  shift_btnCancelModal:     'Cancel',
  shift_btnSaveModal:       'Save',

  shift_exportTitle:        'Export',
  shift_exportDolTitle:     'Timesheet Report',
  shift_exportDolSub:       'Signed PDF with your hours and entries',
  shift_exportInvoiceTitle: 'Invoice PDF',
  shift_exportInvoiceSub:   'Client invoice with hours × rate',

  shift_modeLive:           'Live Clock',
  shift_modeManual:         'Manual Entry',

  shift_fieldWorkplace:     'Workplace',
  shift_selectWorkplace:    'Select a workplace',
  shift_btnAddWorkplace:    'Add workplace',
  shift_fieldEntryType:     'Entry Type',
  shift_typeShift:          'Shift',
  shift_typeWork:           'Work Session',
  shift_typeTravel:         'Travel',
  shift_typeOnCall:         'On-Call',
  shift_typeJobSearch:      'Job Search',

  shift_fieldJobTitle:      'Job Title',
  shift_jobTitlePlaceholder: 'e.g. Line Cook',
  shift_fieldRateOfPay:     'Rate of Pay',
  shift_fieldSchedule:      'Schedule Template',
  shift_scheduleNone:       'None',

  shift_fieldDate:          'Date',
  shift_fieldClockIn:       'Clock In',
  shift_fieldClockOut:      'Clock Out',
  shift_clockInRounded:     '→ rounded {time}',

  shift_fieldUnpaidBreak:   'Unpaid Break',
  shift_breakNone:          'None',
  shift_break15:            '15m',
  shift_break30:            '30m',
  shift_break45:            '45m',
  shift_break60:            '1h',
  shift_breakCustom:        'Custom',
  shift_breakHint:          'Deducted from compensable hours',
  shift_breakPlaceholder:   'min',

  shift_fieldNotes:         'Notes',
  shift_notesPlaceholder:   'Optional…',

  shift_btnClockIn:         'Clock In',
  shift_btnClockOut:        'Clock Out',
  shift_idleHint:           'Select workplace & type in the form, then clock in.',

  shift_manualPreviewTitle: 'Manual Entry Preview',
  shift_manualEstPay:       'Est. {pay}',
  shift_manualEnterTimes:   'Enter times in the form',
  shift_previewGross:       'Gross Time',
  shift_previewCompensable: 'Compensable',
  shift_previewOvertime:    'Overtime',
  shift_previewEstPay:      'Est. Pay',
  shift_btnReset:           'Reset',
  shift_btnSaving:          'Saving…',
  shift_btnSaveEntry:       'Save Entry',
  shift_entrySaved:         'Entry saved',

  shift_sectionTodayActivity: "Today's Activity",
  shift_compensableToday:   'Compensable Today',
  shift_travel:             'Travel',
  shift_spread:             'Spread',

  shift_sectionThisWeek:    'This Week',
  shift_sectionSignExport:  'Export',
  shift_totalHours:         'Total Hours',
  shift_daysWorked:         'Days Worked',
  shift_otHours:            'OT Hours',

  shift_sectionTodayEntries: "Today's Entries",
  shift_ledgerTotal:        'Total: {hours}h compensable',

  shift_sectionSealExport:  'Seal & Export',
  shift_sealSigned:         'Sealed',
  shift_sealReady:          '{n} entry ready to seal | {n} entries ready to seal',
  shift_sealNone:           'No unsealed entries',
  shift_noTodayActivity:    'No activity today',
  shift_noManualEntries:    'No manual entries',
  shift_sealAuditTrail:     'Tamper-evident audit trail',
  shift_btnSigning:         'Sealing…',
  shift_btnResign:          'Re-seal',
  shift_btnSign:            'Seal ({n})',
  shift_btnExport:          'Export',

  shift_otWarning:          'OT: {hours}h at 1.5× applies',

  // ── OcrView ───────────────────────────────────────────────────────────────
  ocr_parsedResult:         'Parsed Result',
  ocr_btnImportToTrack:     'Import to Track',
  ocr_btnClear:             'Clear',
  ocr_scanning:             'Scanning…',
  ocr_tapToScan:            'Tap to scan',
  ocr_btnScanDocument:      'Scan Document',
  ocr_btnUploadDocument:    'Upload Document',

  ocr_sectionDocType:       'Document Type',
  ocr_typePayStub:          'Pay Stub',
  ocr_typeTimesheet:        'Timesheet',
  ocr_typePunchCard:        'Punch Card',
  ocr_typeSchedule:         'Schedule',

  ocr_sectionExtracts:      'Extracts',
  ocr_extractEmpName:       'Employer name',
  ocr_extractPayPeriod:     'Pay period',
  ocr_extractGrossPay:      'Gross pay',
  ocr_extractNetPay:        'Net pay',
  ocr_extractHourlyRate:    'Hourly rate',
  ocr_extractHoursWorked:   'Hours worked',
  ocr_extractDateRange:     'Date range',
  ocr_extractDailyHours:    'Daily hours',
  ocr_extractTotalHours:    'Total hours',
  ocr_extractOvertime:      'Overtime',
  ocr_extractEmployeeName:  'Employee name',
  ocr_extractPunchIn:       'Punch-in times',
  ocr_extractPunchOut:      'Punch-out times',
  ocr_extractDate:          'Date',
  ocr_extractShiftTimes:    'Shift times',
  ocr_extractDaysOfWeek:    'Days of week',
  ocr_extractPosition:      'Position / role',
  ocr_extractLocation:      'Location',

  ocr_privacyBanner:        'OCR runs on-device. No document data leaves your phone.',

  ocr_sectionRecentScans:   'Recent Scans',
  ocr_noScansYet:           'No scans yet',
  config_locationSingular:  'location',
  config_locationPlural:    'locations',
  config_templateSingular:  'template',
  config_templatePlural:    'templates',
  config_profileSingular:   'profile',
  config_profilePlural:     'profiles',
  ocr_tabScan:              'Scan',
  ocr_tabRecent:            'Recent',
}
